module.exports = __webpack_public_path__ + "static/img/1.f00bfce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/1.png
// module id = Z2Gf
// module chunks = 0